(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autronics-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const lightboxSlides = Array.from(gallery.querySelectorAll('[data-gallery-lightbox-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const counters = Array.from(gallery.querySelectorAll('[data-gallery-counter]'));
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const openButtons = Array.from(gallery.querySelectorAll('[data-gallery-open]'));
    let index = 0;
    let touchStartX = 0;
    let lastOpener = null;

    const normalize = (value) => {
      if (!slides.length) return 0;
      return (value + slides.length) % slides.length;
    };

    const show = (value) => {
      index = normalize(value);
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      lightboxSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      counters.forEach((counter) => {
        counter.textContent = `${index + 1} / ${slides.length}`;
      });
      if (thumbs[index]) thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    gallery.querySelectorAll('[data-gallery-prev]').forEach((button) => {
      button.addEventListener('click', () => show(index - 1));
    });

    gallery.querySelectorAll('[data-gallery-next]').forEach((button) => {
      button.addEventListener('click', () => show(index + 1));
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => show(Number(thumb.dataset.index)));
    });

    openButtons.forEach((button, buttonIndex) => {
      button.addEventListener('click', () => {
        if (!dialog) return;
        lastOpener = button;
        show(buttonIndex);
        dialog.showModal();
      });
    });

    const closeButton = gallery.querySelector('[data-gallery-close]');
    if (closeButton && dialog) closeButton.addEventListener('click', () => dialog.close());

    if (dialog) {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (lastOpener) lastOpener.focus();
      });
    }

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });

    gallery.querySelectorAll('[data-gallery-touch]').forEach((surface) => {
      surface.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      surface.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) < 45) return;
        show(distance > 0 ? index - 1 : index + 1);
      }, { passive: true });
    });

    show(0);
  });

  } catch(e) { console.error(e); }
})();
})();
